module.exports = __webpack_public_path__ + "img/1920_banner_1.7f462e11.jpg";